import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Button, debounce, Image } from '@outdoor-voices/ui';
import { isTabletSmall } from '@outdoor-voices/ui/dist/utils/dom/isMobile';
import { memo, useEffect, useState } from 'react';
import { RESIZE } from '@outdoor-voices/ui/dist/config/constants';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { PANEL_WIDTH } from './constants';
import css from './Accordion.module.scss';
import PlusToMinus from '../../components/icons/PlusToMinus';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Item = function Item(_ref) {
  var _ref6;

  var accentColor = _ref.accentColor,
      cta = _ref.cta,
      copy = _ref.copy,
      hoverOverlay = _ref.hoverOverlay,
      icon = _ref.icon,
      iconLarge = _ref.iconLarge,
      id = _ref.id,
      idx = _ref.idx,
      isMobile = _ref.isMobile,
      on = _ref.on,
      open = _ref.open,
      setIndex = _ref.setIndex,
      showImages = _ref.showImages,
      src = _ref.src,
      srcMobile = _ref.srcMobile,
      title = _ref.title,
      url = _ref.url;
  var attrs = open ? {} : {
    'aria-hidden': 'true',
    'aria-expanded': 'false'
  };
  var imageAttrs = isMobile ? {
    height: 240,
    sizes: [320, 600],
    src: srcMobile,
    width: 750
  } : {
    height: 1260,
    sizes: [320, 600, 800, 900],
    src: src,
    width: 840
  };

  var titleEl = /*#__PURE__*/_jsxs("div", {
    className: css.contentWrapper,
    style: {
      color: !open ? accentColor : ''
    },
    children: [/*#__PURE__*/_jsx("div", {
      className: cc([css.icon, _defineProperty({}, css.large, iconLarge), _defineProperty({}, css.mobile, !showImages && open)]),
      dangerouslySetInnerHTML: {
        __html: icon
      }
    }), /*#__PURE__*/_jsx("div", {
      className: cc([css.itemTitle, _defineProperty({}, css.on, on && !open)]),
      children: title
    })]
  });

  var setOpen = function setOpen() {
    return setIndex(idx);
  };

  var onClick = open ? function () {
    return setIndex(null);
  } : setOpen;
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.content, _defineProperty({}, css.open, open)]),
    children: [/*#__PURE__*/_jsxs("button", {
      "aria-controls": "panel-".concat(id),
      "aria-expanded": open ? true : false,
      "aria-label": "Click to expand the ".concat(title, " panel"),
      className: cc([css.button, (_ref6 = {}, _defineProperty(_ref6, css.open, open), _defineProperty(_ref6, css.on, on && !open), _defineProperty(_ref6, css.dark, !showImages && !open), _defineProperty(_ref6, css.hoverOverlay, hoverOverlay), _ref6)]),
      onClick: onClick,
      type: "button",
      children: [titleEl, isMobile && /*#__PURE__*/_jsx(PlusToMinus, {
        open: open
      })]
    }), /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, attrs), {}, {
      className: cc([css.copy, _defineProperty({}, css.open, open)]),
      id: "panel-".concat(id),
      children: [titleEl, /*#__PURE__*/_jsx("p", {
        children: copy
      }), cta && url && /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(Button, {
          ariaLabel: "Click to learn more about ".concat(title),
          big: true,
          borderedInverseHover: true,
          href: url,
          tabIndex: open ? 0 : -1,
          white: true,
          children: cta
        })
      })]
    })), showImages && /*#__PURE__*/_jsx("div", {
      "aria-hidden": "true",
      className: cc([css.image, _defineProperty({}, css.open, open)]),
      role: "presentation",
      children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, imageAttrs), {}, {
        wrap: false
      }))
    })]
  });
};

Item.propTypes = {
  accentColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  copy: PropTypes.string,
  cta: PropTypes.string,
  hoverOverlay: PropTypes.bool,
  icon: PropTypes.string,
  iconLarge: PropTypes.bool,
  id: PropTypes.string,
  idx: PropTypes.number,
  isMobile: PropTypes.bool,
  on: PropTypes.bool,
  setIndex: PropTypes.func,
  open: PropTypes.bool,
  showImages: PropTypes.bool,
  src: PropTypes.string,
  srcMobile: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string
};

var blocksToItems = function blocksToItems(blocks) {
  return blocks.map(function (block) {
    var _block$node = block.node,
        id = _block$node.id,
        backgroundColor = _block$node.backgroundColor,
        cta = _block$node.cta,
        icon = _block$node.icon,
        image = _block$node.image,
        imageMobile = _block$node.imageMobile,
        subtitle = _block$node.subtitle,
        title = _block$node.title,
        titleColor = _block$node.titleColor,
        url = _block$node.url;
    return {
      id: id,
      accentColor: titleColor,
      backgroundColor: backgroundColor,
      cta: cta,
      copy: subtitle,
      icon: icon === null || icon === void 0 ? void 0 : icon.svg,
      src: image ? image.src : '',
      srcMobile: imageMobile ? imageMobile.src : '',
      title: title,
      url: url
    };
  });
};

var Accordion = function Accordion(props) {
  var _props$items;

  var blocks = props.blocks,
      cta = props.cta,
      hoverOverlay = props.hoverOverlay,
      iconLarge = props.iconLarge,
      num = props.num,
      showImages = props.showImages,
      title = props.title,
      url = props.url;
  var items = (_props$items = props.items) !== null && _props$items !== void 0 ? _props$items : [];

  if (blocks) {
    items = blocksToItems(blocks.edges);
  }

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      index = _useState2[0],
      setIndex = _useState2[1];

  var _useState3 = useState(isTabletSmall()),
      _useState4 = _slicedToArray(_useState3, 2),
      isMobile = _useState4[0],
      setIsMobile = _useState4[1];

  var attrs = isMobile ? {} : {
    onMouseLeave: function onMouseLeave() {
      return setIndex(null);
    }
  }; // Change the isMobile state based on the width of the browser

  useEffect(function () {
    var onResize = function onResize() {
      setIsMobile(isTabletSmall());
    }; // Debounce the listener, so we don't re-render too much


    var debouncedResize = debounce(onResize, 500);
    window.addEventListener(RESIZE, debouncedResize); // Remove the listener for cleanup on re-render

    return function () {
      window.removeEventListener(RESIZE, debouncedResize);
    };
  }, []);
  return /*#__PURE__*/_jsxs("section", {
    className: css.root,
    children: [title && /*#__PURE__*/_jsx("h4", {
      className: css.title,
      children: title
    }), /*#__PURE__*/_jsx("ul", _objectSpread(_objectSpread({}, attrs), {}, {
      className: css.list,
      children: items.slice(0, num).map(function (_ref9, idx) {
        var _ref10;

        var accentColor = _ref9.accentColor,
            backgroundColor = _ref9.backgroundColor,
            copy = _ref9.copy,
            cta = _ref9.cta,
            icon = _ref9.icon,
            id = _ref9.id,
            src = _ref9.src,
            srcMobile = _ref9.srcMobile,
            title = _ref9.title,
            url = _ref9.url;
        var open = idx === index;
        var on = index !== null; // change width based on the state
        // Open items are full width, on items are smaller.

        var width = on ? "".concat(PANEL_WIDTH / (num - 1), "px") : "".concat(100 / num, "vw");

        if (open) {
          width = "calc(100vw - ".concat(PANEL_WIDTH, "px)");
        }

        return /*#__PURE__*/_jsxs("li", {
          className: cc([css.item, (_ref10 = {}, _defineProperty(_ref10, css.on, on && !open), _defineProperty(_ref10, css.open, open), _ref10)]),
          style: {
            '--width': width,
            backgroundColor: backgroundColor && !open ? backgroundColor : ''
          },
          children: [!showImages && !open && /*#__PURE__*/_jsx("div", {
            className: css.hoverDarken
          }), /*#__PURE__*/_jsx(Item, {
            accentColor: accentColor,
            copy: copy,
            cta: cta,
            hoverOverlay: hoverOverlay,
            icon: icon,
            iconLarge: iconLarge,
            id: id,
            idx: idx,
            isMobile: isMobile,
            on: on,
            open: open,
            setIndex: setIndex,
            showImages: showImages,
            src: src,
            srcMobile: srcMobile,
            title: title,
            url: url
          })]
        }, id);
      })
    })), cta && url && /*#__PURE__*/_jsx("div", {
      className: css.cta,
      children: /*#__PURE__*/_jsx(Button, {
        "aria-label": "".concat(cta, " ").concat(cta.indexOf(title) > -1 ? '' : title),
        big: true,
        href: url,
        children: cta
      })
    })]
  });
};

Accordion.defaultProps = {
  hoverOverlay: false,
  iconLarge: false,
  num: 5,
  showImages: true,
  title: ''
};
Accordion.propTypes = {
  blocks: PropTypes.shape(),
  cta: PropTypes.string,
  hoverOverlay: PropTypes.bool.isRequired,
  iconLarge: PropTypes.bool.isRequired,
  items: PropTypes.array,
  num: PropTypes.number.isRequired,
  showImages: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string
};
export default /*#__PURE__*/memo(Accordion);